import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import moment from 'moment'
import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import { getAccountNumber, getSourceCode, storeTransaction } from '../../ApiCall'
import CommonLoader from '../../CommonLoader'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import MobileFooter from '../MobileFooter'
import CommonDropDwn from './CommonDropDwn'
import CustomeCss from './paymentmode.css.js'
import Sample from './sampleTextField'
import customStyle from './stylesheet_UHS'
import './transaction.css'
import apiservice from '../../../utils/apiservice'
import axios from 'axios'

const AntTabs = withStyles(customStyle.tabs)(Tabs)

const AntTab = withStyles(theme => customStyle.tab)(props => <Tab disableRipple {...props} />)

const NextButton = withStyles(customStyle.ChangePayButton)(Button)

const PurpleRadio = withStyles(customStyle.radioBtn)(props => <Radio color="default" {...props} />)

const currentYear = new Date().getFullYear()
const next10Years = Array.from({ length: 10 }, (_, index) => currentYear + index)

class PaymentMode extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      activeTab: 0,
      accountTypes: ['CHECKING', 'SAVINGS'],
      bankName: '',
      accountName: localStorage.getItem('guardianName') || localStorage.getItem('subscriberName'),
      accountType: '',
      routingNo: '',
      accountNumber: '',
      cardNumber: '',
      holderName: localStorage.getItem('guardianName') || localStorage.getItem('subscriberName'),
      expiryMonth: '',
      expiryYear: '',
      monthlyDebitDay: '',
      cvv: '',
      selectedValue: '',
      disabled: true,
      disabled2: true,
      errorModal: false,
      MsgModal: '',
      loader: false,
      sourceCode: null,
      empid: null,
      accountNo: null,
      successModal: false,
      errCodeCC: false,
      errCodeACH: false,
      MsgModalerrorFooterACH: '',
      MsgModalerrorFooterCC: '',
      years: next10Years,
      subId: '',
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      sourceCode: localStorage.getItem('sourceid'),
    }
  }
  handleClose = () => {
    //this.setState({open:false})
    this.goBack()
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  componentDidMount() {
    if (localStorage.getItem('SOURCE') !== 'NEO') {
      this.setState({ loader: true })
      this.getSubID()
      getSourceCode()
        .then(res => {
          this.setState(
            {
              loader: false,
              sourceCode: res.data.memberIdSource,
              empid: res.data.empId,
              accountTypes: ['CHECKING', 'SAVINGS']
            },
            () => this.getAccountNumber()
          )
        })
        .catch()
    }
  }

  getAccountNumber = () => {
    // axios.get('http://3.136.92.227:8085/api/v6/transaction/getLast4AccountNumber/')
    getAccountNumber().then(res => {
      // this.setState({accountNo:res.data.response,loader:false})
      if (res.data.code === 200) {
        var accNo = res.data.response
        var star = '*'

        let AccountNo = accNo.split(star).join('X')
        this.setState({ accountNo: AccountNo, loader: false })
      } else if (res.data.code === 202) {
        let x = JSON.parse(res.data.response).error_message
        let errMsg = ''
        if (x.includes('-')) {
          let cds = x.split(' - ')
          errMsg = cds[1]
        } else {
          errMsg = x
        }

        this.setState({
          accountNo: '',
          errorModal: true,
          MsgModal: errMsg
        })
      } else {
        this.setState({ accountNo: '' })
      }
    })
  }
  changeTextFieldHandler = (val, isValid, parentObj) => {
    if (parentObj.label === 'bank_name') {
      if (isValid) {
        this.state.bankName = val
      } else {
        this.state.bankName = ''
      }
    } else if (parentObj.label === 'Account_Name') {
      if (isValid) {
        this.state.accountName = val
      } else {
        this.state.accountName = ''
      }
    } else if (parentObj.label === 'Routing_Number') {
      if (isValid) {
        this.state.routingNo = val
      } else {
        this.state.routingNo = ''
      }
    } else if (parentObj.label === 'Account_Number') {
      if (isValid) {
        this.state.accountNumber = val
      } else {
        this.state.accountNumber = ''
      }
    } else if (parentObj.label === 'Account_Type') {
      if (isValid) {
        this.state.accountType = val
      } else {
        this.state.accountType = ''
      }
    } else if (parentObj.label === 'Card_Number') {
      if (isValid) {
        this.state.cardNumber = val
      } else {
        this.state.cardNumber = ''
      }
    } else if (parentObj.label === 'Holder_Name') {
      if (isValid) {
        this.state.holderName = val
      } else {
        this.state.holderName = ''
      }
    } else if (parentObj.label === 'expiryMonth') {
      if (isValid) {
        let currentDate = new Date()
        let month = currentDate.getMonth() + 1
        let year = currentDate.getFullYear()
        let selectedMon = moment()
          .month(val)
          .format('M')
        if (this.state.expiryYear) {
          if (this.state.expiryYear === year && parseInt(selectedMon) < month) {
            this.state.validMonth = true
            let evt = new CustomEvent('month', { detail: { flag: true } })
            window.dispatchEvent(evt)
          } else {
            this.state.validMonth = false
            let evt = new CustomEvent('month', { detail: { flag: false } })
            window.dispatchEvent(evt)
          }
        }
        this.state.expiryMonth = val
      } else {
        this.state.expiryMonth = ''
      }
    } else if (parentObj.label === 'expiryYear') {
      if (isValid) {
        let date = new Date()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        let selectedMon = moment()
          .month(this.state.expiryMonth)
          .format('M')
        if (val === year && parseInt(selectedMon) < month) {
          this.state.validMonth = true
          let evt = new CustomEvent('month', { detail: { flag: true } })
          window.dispatchEvent(evt)
        } else {
          this.state.validMonth = false
          let evt = new CustomEvent('month', { detail: { flag: false } })
          window.dispatchEvent(evt)
        }
        this.state.expiryYear = val
      } else {
        this.state.expiryYear = ''
      }
    } else if (parentObj.label === 'cvv') {
      if (isValid) {
        this.state.cvv = val
      } else {
        this.state.cvv = ''
      }
    } else if (parentObj.label === 'monthlyDebitDay') {
      if (isValid) {
        this.state.monthlyDebitDay = val
      } else {
        this.state.monthlyDebitDay = ''
      }
    } else if (parentObj.label === 'Street') {
      if (isValid) {
        this.state.userAddress.street = val
      } else {
        this.state.userAddress.street = ''
      }
    }
    this.setState(
      {
        refresh: true
      },
      () => this.validateForm()
    )
  }

  validateForm() {
    if (this.state.activeTab === 0) {
      if (
        this.state.bankName !== '' &&
        this.state.accountName !== '' &&
        this.state.accountNumber !== '' &&
        this.state.accountType !== '' &&
        this.state.routingNo !== ''
      ) {
        this.setState({
          disabled: false
        })
      } else {
        this.setState({
          disabled: true
        })
      }
    } else if (this.state.activeTab === 1) {
      if (
        this.state.cardNumber !== '' &&
        this.state.holderName !== '' &&
        this.state.expiryMonth !== '' &&
        this.state.expiryYear !== '' &&
        this.state.cvv !== '' &&
        !this.state.validMonth
      ) {
        this.setState({
          disabled2: false
        })
      } else {
        this.setState({
          disabled2: true
        })
      }
    }
  }
  handleChange = (event, newValue) => {
    console.log('====================New Value' + newValue)
    this.setState({
      loaderShow: true,
      refresh: true
    })
    let flag
    if (newValue === 0) {
      // flag = 'ACH';
      this.setState({ activeTab: 0 })
    } else {
      // flag = 'CC';
      this.setState({ activeTab: 1 })
    }
  }

  getSubID = () => {
    apiservice.get(process.env.REACT_APP_BASE_URL + 'v3.0/enrollment/getEnrollMemberInfoById/' + this.state.sourceCode).then(res => {
      if (res.data.response !== null) {
        this.setState({ subId: res.data.response.subId }, () => this.getAddress())
      }
    })
  }

  getAddress = () => {
    fetch(
      process.env.REACT_APP_BASE_URL + "v3.0/setupfamily/getMemberInfo/" + this.state.subId
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState(
          {
            loader: false,
            isBillStreetSelected: response.response.mailAddress1 ? true : false,
            userBillingAddress: {
                zip: response.response.mailPostalCode,
                city: response.response.mailCity,
                state: response.response.mailState,
                country: response.response.mailCountry,
                street: response.response.mailAddress1,
                addrs: response.response.address2 || ""
              },
            loader: false,
          },
          () => this.validateForm()
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  isDisableSubmit = () => {
    const restBillingAddress = { ...this.state.userBillingAddress };
    delete restBillingAddress.addrs;
    this.setState({
      isBillAddrValid:
      // !this.state.isBillStreetSelected ||
        Object.values(restBillingAddress).some(
          (x) => x === null || x === ""
        )
    })
  };

  queryAutocompleteForSuggestions(searchValue, addressId, hasSecondaries) {
        let zipCode = "";
        let state = "";
        if (this.state.isMailingStreet) {
            if (this.state.userAddress.postalCode) zipCode = this.state.userAddress.postalCode;
            else state = this.state.userAddress.state;
        } else if (this.state.userBillingAddress) {
            if (this.state.userBillingAddress.zip) zipCode = this.state.userBillingAddress.zip;
            else state = this.state.userBillingAddress.state;
        }

        axios.get(`${process.env.REACT_APP_SMARTY_API}/lookup?auth-id=${process.env.REACT_APP_SMARTY_AUTH_ID}&auth-token=${process.env.REACT_APP_SMARTY_AUTH_TOKEN}&include_only_zip_codes=${zipCode}&include_only_states=${state}&search=${searchValue}&address_id=${addressId}&selected=${hasSecondaries ? searchValue : ""}`)
            .then(results => {
                if (results.data.errors) {
                    if (this.state.isMailingStreet) this.setState({ isMailStreetSelected: true }, () => this.isDisableSubmit())
                        else this.setState({ isBillStreetSelected: true }, () => this.isDisableSubmit())
                }
                else this.setState({ suggestions: results.data.suggestions });
            })
            .catch(err => {
                if (this.state.isMailingStreet) this.setState({ isMailStreetSelected: true }, () => this.isDisableSubmit())
                    else this.setState({ isBillStreetSelected: true }, () => this.isDisableSubmit())
            });
    }

    useAutoCompleteSuggestion(data) {
        return new Promise(resolve => {
            if (this.state.isMailingStreet) {
                this.state.isMailStreetSelected = true
                this.setState({
                    userAddress: {
                        postalCode: data.zipcode,
                        city: data.city.toUpperCase(),
                        state: data.state.toUpperCase(),
                        country: "US",
                        street: data.street_line,
                        addrs: this.state.userAddress.addrs
                    },
                    suggestions: {},
                    makeCityValid: true,
                    makeStateValid: true
                }, () => {
                    this.isDisableSubmit()
                    return resolve
                });
            } else {
                this.state.isBillStreetSelected = true
                this.setState({
                    userBillingAddress: {
                        zip: data.zipcode,
                        city: data.city.toUpperCase(),
                        state: data.state.toUpperCase(),
                        country: "US",
                        street: data.street_line,
                        addrs: this.state.userBillingAddress.addrs
                    },
                    suggestions: {},
                    makeBZipValid: true,
                    makeBCityValid: true,
                    makeBStateValid: true,
                    makeBCountryValid: true,
                }, () => {
                    this.isDisableSubmit()
                    return resolve
                });
            }
            this.isDisableSubmit();
        });
    }

     handlePostalCode = (zipcode, parent, fromDrop) => {
    this.setState({
      loader: true
    });
    // let url = `https://secure.shippingapis.com/ShippingAPI.dll?API=CityStateLookup&XML=<CityStateLookupRequest USERID="935USTGL7449"><ZipCode ID="0"><Zip5>${zipcode}</Zip5></ZipCode></CityStateLookupRequest>`;
     let url = `${process.env.REACT_APP_NEW_BASE_URL_AGENT_DETAIL}agency/api/zipcode/lookup?zipcode=${zipcode}`
    axios
      .get(url)
      .then((response) => {
       var result2 = response.data;
        if (!result2.stateAbbreviation) {
          var evt = new CustomEvent("zip", {
            detail: {
              zipcode: zipcode,
              flag: true,
              errMsg: "Enter valid zip code",
            },
          });
          window.dispatchEvent(evt);
          this.state.userBillingAddress.street = "";
          this.state.userBillingAddress.city = "";
          this.state.userBillingAddress.state = "";
          this.state.userBillingAddress.zip = "";
          this.state.userBillingAddress.country = "US";
          this.state.userBillingAddress.addrs = "";
          this.setState(
            {
              refresh: true,
              loader: false,
            },
            () => this.isDisableSubmit()
          );
        } else {
                if(!fromDrop) this.state.userBillingAddress.street = "";
                else this.state.isValidBillingZip = true
                this.state.userBillingAddress.city = result2.city;
                this.state.userBillingAddress.state = result2.stateAbbreviation;
                this.state.userBillingAddress.zip = result2.zipcode;
                this.state.userBillingAddress.country = "US";
                this.setState(
                  {
                    refresh: true,
                    loader: false,
                  },
                  () => this.isDisableSubmit()
                );
        }
      })
      .catch((error) => {
        let evt = new CustomEvent("zip", {
          detail: {
            zipcode: zipcode,
            flag: true,
            errMsg: "Enter valid zip code",
          },
        });
        window.dispatchEvent(evt);
        this.state.userBillingAddress.city = "";
        this.state.userBillingAddress.state = "";
        this.state.userBillingAddress.zip = "";
        this.state.userBillingAddress.country = "US";
        this.state.userBillingAddress.addrs = "";
        this.setState(
          {
            refresh: true,
            loader: false,
            msgModal: true,
          },
          () => {
            this.changeTextFieldHandler(zipcode, false, parent);
          }
        );
      });
  };

  changeTextFieldHandler = (val, isValid, parentObj) => {
      if (parentObj.flag == "BillAddr") {
        switch (parentObj.label) {
          case "BillAddr-Zip":
            if (isValid) {
              this.state.userBillingAddress.zip = val;
              this.setState({ makeBZipValid: true, loaderShow: true })
              this.handlePostalCode(val, parentObj);
            } else {
              this.setState({ makeBZipValid: false })
              this.state.userBillingAddress.zip = "";
            }
            break;
          case "BillAddr-Street":
            this.state.userBillingAddress.street = isValid ? val : "";
            this.state.isMailingStreet = false
            this.state.isBillStreetSelected = false
            // this.queryAutocompleteForSuggestions(val)
            break;
          case "BillAddr-city":
            if (isValid) {
              this.state.userBillingAddress.city = val.toUpperCase();
              this.setState({ makeBCityValid: true })
            } else {
              this.state.userBillingAddress.city = ""
              this.setState({ makeBCityValid: false })
            }
            break;
          case "BillAddr-state":
            if (isValid) {
              this.state.userBillingAddress.state = val;
              this.setState({ makeBStateValid: true })
            } else {
              this.state.userBillingAddress.state = ""
              this.setState({ makeBStateValid: false })
            }
            break;
          case "BillAddr-country":
            if (isValid) {
              this.state.userBillingAddress.country = val;
              this.setState({ makeBCountryValid: true })
            } else {
              this.state.userBillingAddress.country = ""
              this.setState({ makeBCountryValid: false })
            }
            break;
          case "BillAddr-Address":
            this.state.userBillingAddress.addrs = val;
            break;
          default:
            break;
        }
        this.isDisableSubmit();
      }
      if (parentObj.label === 'bank_name') {
        if (isValid) {
          this.state.bankName = val
        } else {
          this.state.bankName = ''
        }
      } else if (parentObj.label === 'Account_Name') {
        if (isValid) {
          this.state.accountName = val
        } else {
          this.state.accountName = ''
        }
      } else if (parentObj.label === 'Routing_Number') {
        if (isValid) {
          this.state.routingNo = val
          this.state.errCodeACH = false
        } else {
          this.state.routingNo = ''
        }
      } else if (parentObj.label === 'Account_Number') {
        if (isValid) {
          this.state.accountNumber = val
        } else {
          this.state.accountNumber = ''
        }
      } else if (parentObj.label === 'Account_Type') {
        if (isValid) {
          this.state.accountType = val
        } else {
          this.state.accountType = ''
        }
      } else if (parentObj.label === 'Card_Number') {
        if (isValid) {
          this.state.cardNumber = val
          this.state.MsgModalerror = ''
          this.state.errCodeCC = ''
        } else {
          this.state.cardNumber = ''
        }
      } else if (parentObj.label === 'Holder_Name') {
        if (isValid) {
          this.state.holderName = val
        } else {
          this.state.holderName = ''
        }
      } else if (parentObj.label === 'expiryMonth') {
        if (isValid) {
          let currentDate = new Date()
          let month = currentDate.getMonth() + 1
          let year = currentDate.getFullYear()
          let selectedMon = moment()
            .month(val)
            .format('M')
          if (this.state.expiryYear) {
            if (this.state.expiryYear === year && parseInt(selectedMon) < month) {
              this.state.validMonth = true
              let evt = new CustomEvent('month', { detail: { flag: true } })
              window.dispatchEvent(evt)
            } else {
              this.state.validMonth = false
              let evt = new CustomEvent('month', { detail: { flag: false } })
              window.dispatchEvent(evt)
            }
          }
          this.state.expiryMonth = val
        } else {
          this.state.expiryMonth = ''
        }
      } else if (parentObj.label === 'expiryYear') {
        if (isValid) {
          let date = new Date()
          let month = date.getMonth() + 1
          let year = date.getFullYear()
          let selectedMon = moment()
            .month(this.state.expiryMonth)
            .format('M')
          if (val === year && parseInt(selectedMon) < month) {
            this.state.validMonth = true
            let evt = new CustomEvent('month', { detail: { flag: true } })
            window.dispatchEvent(evt)
          } else {
            this.state.validMonth = false
            let evt = new CustomEvent('month', { detail: { flag: false } })
            window.dispatchEvent(evt)
          }
          this.state.expiryYear = val
        } else {
          this.state.expiryYear = ''
        }
      } else if (parentObj.label === 'cvv') {
        if (isValid) {
          this.state.cvv = val
        } else {
          this.state.cvv = ''
        }
      } else if (parentObj.label === 'monthlyDebitDay') {
        if (isValid) {
          this.state.monthlyDebitDay = val
        } else {
          this.state.monthlyDebitDay = ''
        }
      } else if (parentObj.label === 'Street') {
        if (isValid) {
          this.state.userAddress.street = val
        } else {
          this.state.userAddress.street = ''
        }
      }
      this.setState(
        {
          refresh: true
        },
        () => this.validateForm()
      )
    }

  submitAddress = () => {
    this.state.isBillAddrValid = true
    this.setState({
      isBillAddrValid: true,
      addressModal: false,
      isBillStreetSelected: true,
      isFirstTime: true,
      loader: true
    })
    let billObj = {
      subId: this.state.subId,
      mailAddress1: this.state.userBillingAddress.street,
      mailCountry: this.state.userBillingAddress.country,
      mailCity: this.state.userBillingAddress.city,
      mailState: this.state.userBillingAddress.state,
      mailPostalCode: this.state.userBillingAddress.zip,
      address2: this.state.userBillingAddress.addrs
    }

    let obj = new Object()
    obj.subId = this.state.subId
    obj = { ...billObj }
    console.log('valid add')
    apiservice.post(process.env.REACT_APP_BASE_URL + 'v3.0/setupfamily/addMemberAddress', obj).then(response => {
      if (response.data.code === 200) {
        this.setState({
          addressModal: false,
          isBillAddrValid: true,
          // storedTranModal: true,
          waitingRes: 'true'
        })
        localStorage.removeItem('PAYMENT_ERROR')

        let paymentType = ''
        if (this.state.activeTab === 0) {
          paymentType = 'ACH'
        } else {
          paymentType = 'CC'
        }

        const data = {
          accountName: this.state.accountName,
          accountNumber: this.state.accountNumber,
          accountType: this.state.accountType,
          bankName: this.state.bankName,
          cardNumber: this.state.cardNumber,
          cvv: this.state.cvv,
          expiryMonth: this.state.expiryMonth
            ? moment()
                .month(this.state.expiryMonth)
                .format('M')
            : '',
          expiryYear: this.state.expiryYear,
          holderName: this.state.holderName,
          paymentType: paymentType,
          paymentMode: paymentType,
          routingNo: this.state.routingNo,
          source: this.state.sourceCode,
          subId: this.state.subId
        }
        apiservice.post(process.env.REACT_APP_BASE_URL + 'v6/transaction/storeTransaction', data).then(response => {
          if (response.data.code == 200) {
            this.setState({ errorModal: true, open: false, loader: false, MsgModal: 'The payment details have been updated successfully.' })
           this.goBack()
          } else if (response.data.code == 202) {
            let raw = String(response?.data?.response || '')
            let msg = raw

            if (raw.startsWith('500')) {
              let match = raw.match(/"message"\s*:\s*"([^"]+)"/)
              if (match) {
                msg = match[1].split(' REFID')[0].trim()
              }
            } else {
              msg = raw
                .replace('{', '')
                .replace('}', '')
                .replace(/"/g, ' ')
            }

            this.setState({ errorModal: true, MsgModal: msg, loader: false, errCodeACH: true })
          } else if (response.data.code == 204) {
            let x = String('Source is not registered')
            this.setState({ errorModal: true, MsgModal: x, loader: false, errCodeACH: true })
          } else {
            let x = String(response.data.response)
            this.setState({ errorModal: true, MsgModal: x, loader: false, errCodeACH: true })
          }
        })
      }
    })
    this.setState({ disabled: false })
  }

  changePaymentMode = () => {
    this.setState({ loader: true })
    let obj
    var payType = ''
    if (this.state.activeTab == 0) {
      payType = 'ACH'
    } else {
      payType = 'CC'
    }

    obj = {
      source: this.state.sourceCode,
      bankName: this.state.bankName,
      accountName: this.state.accountName,
      accountNumber: this.state.accountNumber,
      accountType: this.state.accountType,
      routingNo: this.state.routingNo,

      cardNumber: this.state.cardNumber,
      holderName: this.state.holderName,
      expiryMonth: this.state.expiryMonth
        ? moment()
            .month(this.state.expiryMonth)
            .format('M')
        : '',
      expiryYear: this.state.expiryYear,
      cvv: this.state.cvv,
      paymentType: payType,
      subId: this.state.subId
    }

    // axios.post('http://3.136.92.227:8085/api/v6/transaction/storeTransaction' ,obj)
    storeTransaction(obj).then(res => {
      if (res.data.code == 200) {
        if (this.state.activeTab == 0) {
          this.setState({
            loader: true
          })
        }
        if (this.state.activeTab == 1) {
          this.setState({
            loader: true
          })
        }
        this.setState({ addressModal: true, loader: false })
      } else if (res.data.code == 202) {
        let raw = res?.data?.response || ''
        let errMsg = ''

        try {
          // Handle new 500 format
          if (raw.startsWith('500')) {
            let match = raw.match(/"message"\s*:\s*"([^"]+)"/)
            if (match) {
              errMsg = match[1].split(' REFID')[0].trim()
            }
          }
          // Old logic
          else {
            let x = JSON.parse(raw).error_message || ''
            if (x.includes('-')) {
              let cds = x.split(' - ')
              errMsg = cds[1]
            } else {
              errMsg = x
            }
          }
        } catch (e) {
          errMsg = 'Something went wrong. Please try again.'
        }

        this.setState({ MsgModalerror: errMsg, loader: false, errCodeACH: true })

        if (this.state.activeTab == 0 && errMsg !== '') {
          this.setState({
            errCodeACH: true,
            cvv: '',
            cardNumber: '',
            errCodeCC: false,
            expiryMonth: '',
            expiryYear: '',
            reqFlag: false
          })

          let evt = new CustomEvent('errorCode', { detail: { flag: true } })
          window.dispatchEvent(evt)
        }

        if (this.state.activeTab == 1) {
          this.setState({
            errCodeCC: true,
            bankName: '',
            accountNumber: '',
            accountType: '',
            routingNo: '',
            errCodeACH: false
          })

          let evt = new CustomEvent('errorCode', { detail: { flag: true } })
          window.dispatchEvent(evt)
        }
      } else if (res.data.code == 204) {
        if (this.state.activeTab == 0) {
          this.setState({
            errorModal: true,
            loader: false,
            MsgModal: 'Source is not registered',
            cvv: '',
            cardNumber: '',
            errCodeCC: false,
            expiryMonth: '',
            expiryYear: '',
            disabled2: true
          })
        } else {
          this.setState({
            errorModal: true,
            MsgModal: 'Source is not registered',
            loader: false,
            errCodeACH: false,
            bankName: '',
            accountNumber: '',
            accountType: '',
            routingNo: '',
            disabled: true
          })
        }
      } else if (res.data.code == 500) {
        if (this.state.activeTab == 0) {
          this.setState({
            errorModal: true,
            loader: false,
            MsgModal: 'Internal server error',
            cvv: '',
            cardNumber: '',
            errCodeCC: false,
            expiryMonth: '',
            expiryYear: '',
            disabled2: true
          })
        } else {
          this.setState({
            errorModal: true,
            MsgModal: 'Internal server error',
            loader: false,
            errCodeACH: false,
            bankName: '',
            accountNumber: '',
            accountType: '',
            routingNo: '',
            disabled: true
          })
        }
      } else {
        let x = JSON.parse(res.data.response).error_message
        let cds = x.split(' - ')
        if (this.state.activeTab == 0) {
          this.setState({
            MsgModal: cds[1],
            errorModal: true,
            loader: false,
            cvv: '',
            cardNumber: '',
            errCodeCC: false,
            expiryMonth: '',
            expiryYear: '',
            disabled2: true
          })
        } else {
          this.setState({
            MsgModal: cds[1],
            errorModal: true,
            loader: false,
            bankName: '',
            accountNumber: '',
            accountType: '',
            routingNo: '',
            disabled: true
          })
        }
      }
    })
  }

  handleCloseErrorModal = () => {
    /*this.getAccountNumber()*/
    this.setState({ errorModal: false })
  }

  handleCloseSuccessModal = () => {
    this.getAccountNumber()
    this.setState({ successModal: false })
    this.goBack()
  }

  handleChangeRadio = event => {
    this.setState({ selectedValue: event.target.value })
  }
  goBack = () => {
    this.props.history.push('/MyTransactionMobile')
  }

  hideModal = event => {
    this.setState(
      {
        disabled: false,
        addressModal: false,
        isBillAddrDiff: false,
        isBillAddrValid: false,
        isFirstTime: true,
        suggestions: { result: [] }
      },
      () => {
        this.validateForm()
      }
    )
  }

  render() {
    let currentScreen = ''
    if (this.state.activeTab === 0) {
      currentScreen = (
        <div className="grid_row1">
          <Grid container style={{ marginTop: '20px' }} justify="center" alignItems="center">
            <Grid item xs={10} sm={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4} sm={4} style={{ marginBottom: '-1%' }}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'Bank_Name'}
                    reqFlag={true}
                    label={'Bank Name'}
                    value={this.state.bankName}
                    disable={false}
                    style={CustomeCss.textField}
                    length={120}
                    fieldType={'bank_name'}
                    errMsg={'Enter valid bank name'}
                    helperMsg={'Bank name required'}
                    parentDetails={{ label: 'bank_name' }}
                    key={0}
                  ></Sample>
                </Grid>
                <Grid item xs={12} sm={4} style={{ marginBottom: '-1%' }}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'Account_Name'}
                    reqFlag={true}
                    label={'Name on Account'}
                    value={this.state.accountName}
                    disable={false}
                    style={CustomeCss.textField}
                    length={120}
                    fieldType={'accountName'}
                    errMsg={'Enter valid account name'}
                    helperMsg={'Name on account required'}
                    parentDetails={{ label: 'Account_Name' }}
                    key={0}
                  ></Sample>
                </Grid>
                <Grid item xs={12} md={4} sm={3} style={{ marginBottom: '-1%' }}>
                  <CommonDropDwn
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'Account Type'}
                    label={'Account Type'}
                    value={this.state.accountType}
                    disable={false}
                    style={customStyle.dropDown}
                    fieldType={'dropDwn'}
                    helperMsg={'Select account type'}
                    List={this.state.accountTypes}
                    parentDetails={{ label: 'Account_Type' }}
                  ></CommonDropDwn>
                </Grid>
              </Grid>
              <Grid container spacing={3} style={{ marginTop: '1.5%' }}>
                <Grid item xs={12} md={6} sm={5} style={{ marginBottom: '-3%' }}>
                  {this.state.MsgModal != '' ? (
                    <Sample
                      setChild={this.changeTextFieldHandler.bind(this)}
                      name={'Routing_Number'}
                      MsgModalerror={this.state.MsgModal}
                      ErrCode={this.state.errCodeACH}
                      reqFlag={true}
                      label={'Routing Number'}
                      value={this.state.routingNo}
                      disable={false}
                      style={CustomeCss.textField}
                      length={9}
                      fieldType={'routingNo'}
                      errMsg={'Enter valid routing number'}
                      helperMsg={this.state.MsgModal}
                      parentDetails={{ label: 'Routing_Number' }}
                      key={0}
                    ></Sample>
                  ) : (
                    <Sample
                      setChild={this.changeTextFieldHandler.bind(this)}
                      name={'Routing_Number'}
                      reqFlag={true}
                      label={'Routing Number'}
                      value={this.state.routingNo}
                      disable={false}
                      style={CustomeCss.textField}
                      length={9}
                      fieldType={'routingNo'}
                      errMsg={'Enter valid routing number'}
                      helperMsg={'Routing number required'}
                      parentDetails={{ label: 'Routing_Number' }}
                      key={0}
                    ></Sample>
                  )}
                </Grid>
                <Grid item xs={12} md={6} sm={6}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'Account_Number'}
                    reqFlag={true}
                    label={'Account Number'}
                    value={this.state.accountNumber}
                    disable={false}
                    style={CustomeCss.textField}
                    length={17}
                    fieldType={'accountNumber'}
                    errMsg={'Account number up to 17 digits'}
                    helperMsg={'Account number required'}
                    parentDetails={{ label: 'Account_Number' }}
                    key={0}
                  ></Sample>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div className="Bottom-Blue">
            <Grid container>
              <Grid item xs={6} style={{ textAlign: 'center' }}>
                <Button variant="secondary" onClick={this.handleClose} class="ButtonBGMobile">
                  CANCEL
                </Button>
              </Grid>
              <Grid item xs={6} style={{ textAlign: 'center' }}>
                <NextButton variant="contained" color="primary" onClick={this.changePaymentMode} disabled={this.state.disabled}>
                  DONE
                </NextButton>
              </Grid>
            </Grid>
          </div>
        </div>
      )
    } else if (this.state.activeTab === 1) {
      currentScreen = (
        <div className="grid_row1">
          <Grid container style={{ marginTop: '20px' }} justify="center" alignItems="center">
            <Grid item xs={10} sm={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} style={{ marginBottom: '-3%' }}>
                  {this.state.MsgModal != '' ? (
                    <Sample
                      setChild={this.changeTextFieldHandler.bind(this)}
                      name={'Card_Number'}
                      MsgModalerror={this.state.MsgModal}
                      ErrCode={this.state.errCodeCC}
                      reqFlag={true}
                      label={'Card Number'}
                      value={this.state.cardNumber}
                      disable={false}
                      style={CustomeCss.textField}
                      length={16}
                      fieldType={'cardNumber'}
                      errMsg={'Card number up to 15 or 16 digits'}
                      helperMsg={this.state.MsgModal}
                      parentDetails={{ label: 'Card_Number' }}
                    ></Sample>
                  ) : (
                    <Sample
                      setChild={this.changeTextFieldHandler.bind(this)}
                      name={'Card_Number'}
                      reqFlag={true}
                      label={'Card Number'}
                      value={this.state.cardNumber}
                      disable={false}
                      style={CustomeCss.textField}
                      length={16}
                      fieldType={'cardNumber'}
                      errMsg={'Card number up to 15 or 16 digits'}
                      helperMsg={'Card number required'}
                      parentDetails={{ label: 'Card_Number' }}
                    ></Sample>
                  )}
                </Grid>
                <Grid item xs={12} md={6} sm={5}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'Holder_Name'}
                    reqFlag={true}
                    label={'Card Holder Name'}
                    value={this.state.holderName}
                    disable={false}
                    style={CustomeCss.textField}
                    length={25}
                    fieldType={'holderName'}
                    errMsg={'Enter valid card holder name'}
                    helperMsg={'Card holder name required'}
                    parentDetails={{ label: 'Holder_Name' }}
                  ></Sample>
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginTop: '2%' }}>
                <Grid item xs={12} sm={4}>
                  <CommonDropDwn
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'expiryMonth'}
                    label={'Expiration Month'}
                    value={this.state.expiryMonth}
                    disable={false}
                    style={customStyle.dropDown}
                    fieldType={'dropDwn'}
                    helperMsg={'Select expiration month'}
                    errMsg={"The expiration date is before today's date. Enter valid expiration month"}
                    List={this.state.months}
                    parentDetails={{ label: 'expiryMonth', val: this.state.expiryYear }}
                    key={1}
                  ></CommonDropDwn>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <CommonDropDwn
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'expiryYear'}
                    label={'Expiration Year'}
                    value={this.state.expiryYear}
                    disable={false}
                    style={customStyle.dropDown}
                    fieldType={'dropDwn'}
                    helperMsg={'Select expiration year'}
                    errMsg={"The expiration date is before today's date. Enter valid expiration year"}
                    List={this.state.years}
                    parentDetails={{ label: 'expiryYear', val: this.state.expiryMonth }}
                    key={1}
                  ></CommonDropDwn>
                </Grid>
                <Grid item xs={12} md={4} sm={3}>
                  <Sample
                    setChild={this.changeTextFieldHandler.bind(this)}
                    name={'cvv'}
                    label={'CVV'}
                    reqFlag={true}
                    value={this.state.cvv}
                    disable={false}
                    style={CustomeCss.textField}
                    length={4}
                    fieldType={'cvv'}
                    errMsg={'Enter valid CVV'}
                    helperMsg={'CVV required'}
                    parentDetails={{ label: 'cvv' }}
                    key={1}
                  ></Sample>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div className="Bottom-Blue">
            <Grid container>
              <Grid item xs={6} style={{ textAlign: 'center' }}>
                <Button variant="secondary" onClick={this.handleClose} class="ButtonBGMobile">
                  CANCEL
                </Button>
              </Grid>
              <Grid item xs={6} style={{ textAlign: 'center' }}>
                <NextButton variant="contained" color="primary" onClick={this.changePaymentMode} disabled={this.state.disabled2}>
                  DONE
                </NextButton>
              </Grid>
            </Grid>
          </div>
        </div>
      )
    }

    return (
      <div style={{ backgroundColor: '#ffffff' }}>
        {this.state.loader ? <CommonLoader /> : null}

        {/* <MobileHeader name="Change Payment Method" /> */}

        <div className="mobileHeaderWrapper">
          <ArrowBackIcon style={{ width: '24px', height: '24px', color: '#2e3192' }} onClick={this.goBack} />
          <div className="mobileHeaderTitle">Change Payment Method </div>
        </div>
        {localStorage.getItem('SOURCE') === 'NEO' ? (
          <div className="mobileCommonBody">
            <div style={{ padding: '180px 0px', textAlign: 'center' }} className="mobile_data_not_found">
              To change your payment method, call Member Services team at : {localStorage.getItem('CONTACT_NUMBER')} , Monday through Friday
              8:00 am to 8:00 pm CST.
            </div>
          </div>
        ) : (
          <div className="mobileCommonBody">
            <p class="The-fellowship-incurs-additional-fees-related-to-p_mobile">
              The fellowship incurs additional fees related to processing credit cards that we do not incur when processing ACH payments. We
              therefore encourage our members to pay by ACH, yet offer credit card payments as an option as well. If you choose to pay by
              credit card, you will incur an additional 3.5% fee to cover the fellowship’s cost.
              {/* <br/><br/>Last used account:{this.state.accountNo}  */}
              {/* {this.state.accountNo!=null?
                 <> {this.state.accountNo} this is your last used account for recurring.</>
                  :""} */}
            </p>
            <Grid container>
              <Grid item xs={12} sm={12}>
                <table className="Last_4_digt_mobile">
                  <tr>
                    <td className="td_style1_mobile">Account Number currently on file</td>
                    <td className="td_style_mobile" style={{ verticalAlign: 'middle' }}>
                      {this.state.accountNo}
                    </td>
                  </tr>
                </table>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={12}>
                <AntTabs value={this.state.activeTab} onChange={this.handleChange} indicatorColor="primary" textColor="primary">
                  <AntTab
                    label="ACH DEBIT"
                    className="ant-col-15 tabBtn tabFirst"
                    icon={
                      this.state.activeTab == 0 ? (
                        <RadioButtonCheckedIcon style={{ marginBottom: 4, marginRight: 5 }} />
                      ) : (
                        <RadioButtonUncheckedIcon style={{ marginBottom: 4, marginRight: 5 }} />
                      )
                    }
                  />
                  <AntTab
                    label="CREDIT CARD"
                    className="ant-col-15 tabBtn tabSecond"
                    icon={
                      this.state.activeTab == 1 ? (
                        <RadioButtonCheckedIcon style={{ marginBottom: 4, marginRight: 5 }} />
                      ) : (
                        <RadioButtonUncheckedIcon style={{ marginBottom: 4, marginRight: 5 }} />
                      )
                    }
                  />
                </AntTabs>
              </Grid>
            </Grid>
            {/* <ChatIcon  shiftup={true} /> */}

            {currentScreen}
          </div>
        )}
        {/* =================================================== */}

        <div class="fixed-bottom">
          <MobileFooter name="Transaction" />
        </div>

        <Modal size="lg" show={this.state.open} onHide={this.handleClose} centered>
          <Modal.Body></Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose} class="ButtonBG">
              CANCEL
            </Button>
            <Button variant="primary" onClick={this.handleClose} class="ButtonBG">
              DONE
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ===============================Error Modal====================================== */}

        <Modal size="small" show={this.state.errorModal} onHide={this.handleCloseErrorModal} centered backdrop="static">
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <b> {this.state.MsgModal}</b>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseErrorModal} class="ButtonBG">
              OK
            </Button>
          </Modal.Footer>
        </Modal>
        {/* =====================================Success Modal=========================================== */}

        <Modal size="small" show={this.state.successModal} onHide={this.handleCloseSuccessModal} centered backdrop="static">
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <b> {this.state.MsgModal}</b>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseSuccessModal} class="ButtonBG">
              OK
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal size="lg" show={this.state.addressModal} onHide={event => this.hideModal(event)} backdrop="static" centered>
          <Modal.Header style={customStyle.modal_header} closeButton>
            <Modal.Title>Billing Address</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              maxHeight: '450px',
              overflowY: 'auto',
              textAlign: 'justify',
              wordSpacing: '2px'
            }}
          >
            <div>
              <>
                <h6 style={{ paddingTop: '10px' }}>Billing Address: </h6>
                <Grid container direction="row" spacing={1} xs={12} md={12} lg={12}>
                  <Grid item xs={6} md={6} lg={4}>
                    <div style={customStyle.EnrollNew1ZipPaymentModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress?.zip}
                        name={'Zip'}
                        label={'Zip Code'}
                        reqFlag={true}
                        disable={false}
                        style={customStyle.textFieldWrp1}
                        length={5}
                        fieldType={'zip'}
                        errMsg={'Enter Valid Zip Code'}
                        helperMsg={'Zip Code Required'}
                        parentDetails={{
                          flag: 'BillAddr',
                          label: 'BillAddr-Zip'
                        }}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={6} lg={4}>
                    <div style={customStyle.EnrollNew1ZipPaymentModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress?.street}
                        name={'Street_suite'}
                        label={'Street,Suite'}
                        reqFlag={true}
                        disable={false}
                        style={customStyle.textFieldWrp1}
                        length={55}
                        fieldType={'street'}
                        errMsg={'Enter valid street'}
                        helperMsg={'Street required'}
                        parentDetails={{
                          flag: 'BillAddr',
                          label: 'BillAddr-Street'
                        }}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1ZipPaymentModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress?.addrs}
                        name={'Street_address'}
                        label={'Street Address 2'}
                        disable={false}
                        style={customStyle.textFieldWrp1}
                        length={55}
                        fieldType={'street'}
                        errMsg={'Enter valid street'}
                        parentDetails={{
                          flag: 'BillAddr',
                          label: 'BillAddr-Address'
                        }}
                      ></Sample>
                    </div>
                  </Grid>
                </Grid>

                <Grid container direction="row" spacing={1} xs={12} md={12} lg={12}>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1CityPayModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        value={this.state.userBillingAddress?.city}
                        name={'City'}
                        label={'City'}
                        reqFlag={true}
                        disable={false}
                        style={customStyle.textFieldWrp1}
                        length={100}
                        fieldType={'city'}
                        errMsg={'Enter valid city'}
                        helperMsg={'City required'}
                        parentDetails={{
                          flag: 'BillAddr',
                          label: 'BillAddr-city'
                        }}
                        makeValid={this.state.makeBCityValid}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1StatePayModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        name={'State'}
                        label={'State'}
                        value={this.state.userBillingAddress?.state}
                        reqFlag={true}
                        disable={true}
                        style={customStyle.textFieldWrp1}
                        length={2}
                        fieldType={'text'}
                        errMsg={'Enter valid state'}
                        helperMsg={'State required'}
                        parentDetails={{
                          flag: 'BillAddr',
                          label: 'BillAddr-state'
                        }}
                        makeValid={this.state.makeBStateValid}
                      ></Sample>
                    </div>
                  </Grid>
                  <Grid item xs={6} md={4} lg={4}>
                    <div style={customStyle.EnrollNew1CountryPayModal}>
                      <Sample
                        setChild={this.changeTextFieldHandler.bind(this)}
                        name={'Country'}
                        label={'Country'}
                        value={this.state.userBillingAddress?.country}
                        reqFlag={true}
                        disable={true}
                        style={customStyle.textFieldWrp1}
                        length={2}
                        fieldType={'text'}
                        errMsg={'Enter valid country'}
                        helperMsg={'Country required'}
                        parentDetails={{
                          flag: 'BillAddr',
                          label: 'BillAddr-country'
                        }}
                        makeValid={this.state.makeBCountryValid}
                      ></Sample>
                    </div>
                  </Grid>
                </Grid>
              </>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="contained" color="primary" onClick={event => this.hideModal(event)} style={customStyle.m10}>
              CANCEL
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={this.state.isBillAddrValid}
              onClick={this.submitAddress}
              style={customStyle.m10}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}
export default PaymentMode
